import { Component, signal, computed, model } from '@angular/core';
import { Store } from '@ngrx/store';
import { CargoHelper, ICargo } from '@pmis3/master-data-core';
import { selectCargoOperations, selectCargoTypes, selectCargoUnitTypes, VesselActivityHelper } from '@pmis3/vessel-activity-core';
import { CommonModule } from '@angular/common';
import { KENDO_LABELS } from "@progress/kendo-angular-label";
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { IconsModule } from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";

@Component({
    selector: 'pmis3-vessel-visit-detail-movement-cargo',
    standalone: true,
    imports: [
        CommonModule,
        KENDO_LABELS,
        KENDO_INPUTS,
        KENDO_DROPDOWNS,
        IconsModule,
        KENDO_BUTTONS
    ],
    templateUrl: 'vessel-visit-detail-movement-cargo.component.html',
    styleUrl: 'vessel-visit-detail-movement-cargo.component.scss'
})
export class VesselVisitDetailMovementCargoComponent {
    cargoTypes = this.store.selectSignal(selectCargoTypes);
    cargoUnitTypes = this.store.selectSignal(selectCargoUnitTypes);
    cargoOperations = this.store.selectSignal(selectCargoOperations);

    cargo = model.required<ICargo>();

    readonly valid = computed(() => ({
        cargoTypeId:            CargoHelper.cargoFieldIsValid('cargoTypeId',            this.cargo()),
        unitId:                 CargoHelper.cargoFieldIsValid('unitId',                 this.cargo()),
        quantity:               CargoHelper.cargoFieldIsValid('quantity',               this.cargo()),
        cargoOperationTypeId:   CargoHelper.cargoFieldIsValid('cargoOperationTypeId',   this.cargo()),
    }));

    onCargoTypeChange(typeId: number) {
        this.cargo.set({
            ...this.cargo(),
            cargoTypeId: typeId
        })
    }

    onCargoUnitChange(unitId: number) {
        this.cargo.set({
            ...this.cargo(),
            unitId: unitId
        })
    }

    onCargoQuantityChange(quantity: number) {
        this.cargo.set({
            ...this.cargo(),
            quantity: quantity
        })
    }

    onCargoOperationChange(operationId: number) {
        this.cargo.set({
            ...this.cargo(),
            cargoOperationTypeId: operationId
        })
    }

    onDelete() {
        this.cargo.set({
            ...this.cargo(),
            isDeleted: true
        })
    }

    cargoFieldIsValid(field: keyof ICargo) {
        return CargoHelper.cargoFieldIsValid(field, this.cargo());
    }
    
    constructor(private store: Store<any>) {}
}